/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Notify } from "../../../../component/Notify";
import { Loading } from "../../../../component/Loading";
import {
  getFromlocalstorage,
} from "../../../../component/MaHoaDuLieu";
import { useUser } from "../../../../component/UserProvider/UserProvider";

function MatKhauRutTien() {
  const initialData =
    JSON.parse(getFromlocalstorage("data_u"));

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [Message, setMessage] = useState("");
  const [typenoti, settypenoti] = useState("error");

  const apiUrl = process.env.REACT_APP_API_BACKEND;
  const hasFetched = useRef(false);
  const { user, fetchUser } = useUser();

  // ตรวจสอบว่าผู้ใช้มีรหัสผ่านถอนเงินเดิมหรือไม่
  useEffect(() => {
    if (initialData && !hasFetched.current) {
      fetchUser(initialData._id);
      hasFetched.current = true;
    }
  }, [initialData]);

  const hasOldPassword = user
    ? user.withdrawal_password !== 0
    : initialData.withdrawal_password !== 0;

  useEffect(() => {
    if (!hasOldPassword) {
      setOldPassword("");
    }
  }, [hasOldPassword]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (hasOldPassword && !oldPassword) {
      setMessage("กรุณากรอกรหัสผ่านถอนเงินเดิม");
      settypenoti("error");
      return;
    }

    if (!newPassword || !confirmPassword) {
      setMessage("กรุณากรอกรหัสผ่านถอนเงินใหม่");
      settypenoti("error");
      return;
    }

    if (newPassword !== confirmPassword) {
      setMessage("รหัสผ่านใหม่ไม่ตรงกัน");
      settypenoti("error");
      return;
    }

    setLoading(true);

    const url = `${apiUrl}/postmkruttien/${initialData._id}`;

    const body = hasOldPassword
      ? {
          withdrawal_password_old: oldPassword,
          withdrawal_password: newPassword,
        }
      : {
          withdrawal_password: newPassword,
        };

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (response.ok) {
        setMessage("อัปเดตรหัสผ่านถอนเงินสำเร็จ");
        settypenoti("success");

        await fetchUser(initialData._id);

        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        setMessage(
          result.message === "Mật khẩu cũ không đúng"
            ? "รหัสผ่านเดิมไม่ถูกต้อง"
            : "รหัสผ่านต้องเป็นตัวเลข"
        );

        settypenoti("error");
      }
    } catch (error) {
      console.error("เกิดข้อผิดพลาดในการเรียก API:", error);

      setMessage("เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน");
      settypenoti("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ marginTop: "110px" }}>
      <form onSubmit={handleSubmit}>
        <div className="matkhau_dn_lwrap">

          {/* รหัสผ่านเดิม */}
          {hasOldPassword && (
            <div className="matkhau_dn_cell">
              <div className="matkhau_dn_cell_icon">
                <FontAwesomeIcon
                  icon={faLock}
                  className="matkhau_dn_cell_icon_icon"
                />
              </div>

              <div className="matkhau_dn_cell_input">
                <input
                  type="password"
                  placeholder="กรอกรหัสผ่านถอนเงินเดิม"
                  required={hasOldPassword}
                  value={oldPassword}
                  onChange={(e) =>
                    setOldPassword(e.target.value)
                  }
                />
              </div>
            </div>
          )}

          {/* รหัสผ่านใหม่ */}
          <div className="matkhau_dn_cell">
            <div className="matkhau_dn_cell_icon">
              <FontAwesomeIcon
                icon={faLock}
                className="matkhau_dn_cell_icon_icon"
              />
            </div>

            <div className="matkhau_dn_cell_input">
              <input
                type="password"
                placeholder="กรอกรหัสผ่านถอนเงินใหม่"
                required
                value={newPassword}
                onChange={(e) =>
                  setNewPassword(e.target.value)
                }
              />
            </div>
          </div>

          {/* ยืนยันรหัสผ่านใหม่ */}
          <div className="matkhau_dn_cell">
            <div className="matkhau_dn_cell_icon">
              <FontAwesomeIcon
                icon={faLock}
                className="matkhau_dn_cell_icon_icon"
              />
            </div>

            <div className="matkhau_dn_cell_input">
              <input
                type="password"
                placeholder="กรอกรหัสผ่านถอนเงินใหม่อีกครั้ง"
                required
                value={confirmPassword}
                onChange={(e) =>
                  setConfirmPassword(e.target.value)
                }
              />
            </div>
          </div>
        </div>

        <p
          style={{
            textAlign: "center",
            marginTop: "10px",
          }}
        >
          <button
            className="matkhau_dn_submit_btn"
            type="submit"
          >
            ยืนยัน
          </button>
        </p>
      </form>

      {Message && (
        <Notify
          message={Message}
          type={typenoti}
          setcontent={setMessage}
        />
      )}

      <Loading isLoading={loading} />
    </div>
  );
}

export default MatKhauRutTien;